import React from "react";
import { NavLink } from "react-router-dom";
import { MessageSquare, Settings, StickyNote, Workflow } from "lucide-react";

export default function BottomNav() {
    return (
        <nav
            data-testid="bottom-nav"
            className="md:hidden fixed bottom-0 left-0 right-0 border-t border-border bg-[#0A0A0A]/95 backdrop-blur-xl z-40 flex justify-around items-stretch safe-bottom"
            style={{ height: "calc(64px + env(safe-area-inset-bottom, 0px))" }}
        >
            <TabLink to="/chat" icon={<MessageSquare className="w-5 h-5" />} label="Chat" testId="bottomnav-chat" />
            <TabLink to="/bots" icon={<Workflow className="w-5 h-5" />} label="Bots" testId="bottomnav-bots" />
            <TabLink to="/notas" icon={<StickyNote className="w-5 h-5" />} label="Notas" testId="bottomnav-notes" />
            <TabLink to="/configuracoes" icon={<Settings className="w-5 h-5" />} label="Perfil" testId="bottomnav-settings" />
        </nav>
    );
}

function TabLink({ to, icon, label, testId }) {
    return (
        <NavLink
            to={to}
            data-testid={testId}
            end
            className={({ isActive }) =>
                `relative flex-1 flex flex-col items-center justify-center gap-1 py-2 transition-colors active:bg-muted/30 ${
                    isActive ? "text-primary" : "text-muted-foreground"
                }`
            }
        >
            {({ isActive }) => (
                <>
                    {isActive && (
                        <span className="absolute top-0 left-1/2 -translate-x-1/2 w-10 h-0.5 bg-primary rounded-b-sm" />
                    )}
                    {icon}
                    <span className="text-[10px] font-mono tracking-[0.12em] uppercase">{label}</span>
                </>
            )}
        </NavLink>
    );
}
